module.exports = __webpack_public_path__ + "static/media/bistecca-cover.7ab9a177.jpg";